import FormBlock from '../form-block';
import ShiftItem from './shift-item';
import ShiftForm from './shift-form';
import React, {useState} from 'react';
import {Shift, ShiftSchedule} from '../../../../api/types';
import {useForm, FormProvider} from 'react-hook-form';
import * as uuid from 'uuid';
import {DeleteDialog} from '../../../../components/Dialog';
import ShiftInfo from '../shift-info';

type ShiftBlockProps = {
  shiftSchedules: ShiftSchedule[];
  shifts: Shift[];
  onChange: (shifts: Shift[]) => void;
  selected: string[];
};
function ShiftBlock({
  shifts,
  shiftSchedules,
  onChange,
  selected,
}: ShiftBlockProps) {
  const [showShiftForm, setShowShiftForm] = useState(false);
  const [triggerValidate, setTriggerValidate] = useState(false);
  const [deleteId, setDeleteId] = useState<null | string>(null);
  const methods = useForm<Shift>({ mode: 'onChange' });
  const {reset} = methods;
  return (
    <FormBlock
      title={
        <span>
          步驟2. 班別(班次群組設定)
          <ShiftInfo />
        </span>
      }
      formType={'班別'}
      onAddItem={() => {
        reset({
          shiftSchedules: [],
          isAutoGenerateCalendar: true,
        });
        setShowShiftForm(true);
      }}
      disabled={shiftSchedules.length === 0}
      data-test-id={'shift'}
    >
      {shifts?.map((item, idx) => {
        const hasInvalidShift = item.shiftSchedules?.some(shiftSchedule =>
          shiftSchedules.find(s => s.id === shiftSchedule.shiftScheduleId)?.cycleType !== item.cycleType)
        const hasError = Object.keys(item?.error || {}).length > 0
        const defaultShiftSchedule = shiftSchedules.find(
          s => s.id === item.defaultShiftSchedule?.shiftScheduleId,
        )
        return (
          <ShiftItem
            key={`shift_item_${idx}`}
            item={{
              ...item,
              defaultShiftSchedule: defaultShiftSchedule ? {
                ...item.defaultShiftSchedule,
                shiftScheduleName: defaultShiftSchedule.name,
              } : undefined,
              shiftSchedules: item.shiftSchedules?.map(shiftSchedule => ({
                ...shiftSchedule,
                shiftScheduleName:
                  shiftSchedules.find(s => s.id === shiftSchedule.shiftScheduleId)
                    ?.name || '',
              })),
            }}
            idx={idx}
            onEdit={async item => {
              reset(item);
              setShowShiftForm(true);
              if (hasError || hasInvalidShift) {
                setTriggerValidate(true);
              }
            }}
            onRemove={id => setDeleteId(id)}
            disabled={selected.indexOf(item.id) !== -1}
            editabled={idx !== 0}
            error={hasError || hasInvalidShift}
          />
        )}
      )}

      <FormProvider {...methods}>
        <input
          ref={methods.register}
          name={'standardShiftSchedule.shiftScheduleId'}
          type={'hidden'}
        />
        <input
          ref={methods.register}
          name={'standardShiftSchedule.shiftScheduleName'}
          type={'hidden'}
        />
        <ShiftForm
          isOpen={showShiftForm}
          onClose={() => {
            setShowShiftForm(false)
            setTriggerValidate(false);
          }}
          onConfirm={shift => {
            delete shift.error
            if (shift.id) {
              const idx = shifts.findIndex(i => i.id === shift.id);
              if (idx !== -1) {
                onChange([
                  ...shifts.slice(0, idx),
                  shift,
                  ...shifts.slice(idx + 1, shifts.length),
                ]);
              }
            } else {
              onChange([...shifts, {...shift, id: uuid.v4()}]);
            }
            setShowShiftForm(false);
            setTriggerValidate(false);
          }}
          shiftSchedules={shiftSchedules}
          triggerValidate={triggerValidate}
        />
      </FormProvider>
      <DeleteDialog
        isOpen={deleteId !== null}
        onCancel={() => setDeleteId(null)}
        onConfirm={() => {
          onChange(shifts.filter(i => i.id !== deleteId));
          setDeleteId(null);
        }}
      />
    </FormBlock>
  );
}

export default ShiftBlock;
